import {
  FETCH_SHOWCASE,
  FETCH_SHOWCASE_FAIL,
  FETCH_SHOWCASE_SUCCESS,
} from 'redux/Reducers/Showcases/ShowcasesReducer';
import Store from 'redux/store';
import { cloudloyalty } from '../clients';

/* eslint-disable */
const FetchShowcase = async (
  User,
  finallyCallback = () => {},
  { showcaseType, identifier, ...rest },
) => {
  const formatToParams = (decodeObject) => {
    let items = []
    Object.keys(decodeObject).forEach((k) => {
      if (k !== 'pipeInstanceSingleton') items.push(`${k}=${decodeObject[k]}`)
    })

    return items.join('&')
  }
  const urlFormat = () => {
    if (Object.keys(rest).length > 1) {
      return `/v2/showcases/${identifier}/${showcaseType}?cachedPrice=true&${formatToParams(rest)}`
    }
    return `/v2/showcases/${showcaseType}?identifier=${identifier}&cachedPrice=true${(Object.keys(rest).length > 1) ? `&${ formatToParams(rest) }`: ''}`
  }
  Store.dispatch({ type: FETCH_SHOWCASE });
  const url = urlFormat()
  cloudloyalty(User).get(url).then((response) => {
    Store.dispatch({
      type: FETCH_SHOWCASE_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_SHOWCASE_FAIL,
      error: e,
      payload: {
        error: e,
        identifier,
        type: showcaseType,
      }
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export default FetchShowcase;
